import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=f45ce0de&scoped=true&"
import script from "./ProfileList.vue?vue&type=script&lang=js&"
export * from "./ProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ce0de",
  null
  
)

export default component.exports